/**
 * account-ui.tsx — Mảnh giao diện dùng chung cho khu "Cài đặt cá nhân":
 * tiêu đề mục có vạch xanh bên trái và hàng "nhãn — nội dung" kiểu SaleSmartly.
 */
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function AccountSection({
  title,
  description,
  children,
  className,
}: {
  title: string
  description?: string
  children: ReactNode
  className?: string
}) {
  return (
    <section className={cn('space-y-3', className)}>
      <div>
        <h2 className="border-l-[3px] border-primary pl-2.5 text-[15px] font-medium leading-5">{title}</h2>
        {description && <p className="mt-1 pl-[13px] text-xs text-muted-foreground">{description}</p>}
      </div>
      <div className="divide-y rounded-lg border bg-card">{children}</div>
    </section>
  )
}

/** Một hàng cài đặt: nhãn (+ mô tả) bên trái, điều khiển bên phải; xếp dọc trên màn hẹp. */
export function AccountRow({
  label,
  hint,
  children,
}: {
  label: string
  hint?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-2 px-4 py-3.5 lg:flex-row lg:items-center lg:gap-6">
      <div className="min-w-0 lg:w-56 lg:shrink-0">
        <p className="text-sm font-medium">{label}</p>
        {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
      </div>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  )
}
